import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function NoResults() {
    const {
        response: { query }
    } = useAppState()

    useEffect(()=>{
        nostojs(function(api) {
            var request = api.createRecommendationRequest();
            request.addElements(["noresults-nosto-1"]);
            request.loadRecommendations();
        });

        jQuery(".ns-premodal, .ns-overlay").hide();
    })

    return (
        <div class="ns-text-align-center ns-my-5 ns-mx-0">
            <h3 class="">No results found for '{query}'</h3>
            <div class="nosto-rec-container">
                <div class="nosto_element" id="noresults-nosto-1"></div>
            </div>
        </div>
    )
}
